module.exports = __webpack_public_path__ + "img/ministero_difesa_zoom.1231c913.png";